module.exports = __webpack_public_path__ + "assets/img/icon3.2bb47c9c.svg";